<template>
    <div class="pay">
      <van-nav-bar
        title="健康码"
        left-text="返回"
        right-text=""
        left-arrow
        @click-left="$router.go('-1')"
        @click-right=""
      />
      <van-notice-bar :scrollable="false" text="请手机打开孩子健康码截屏后上传" />
      <van-notice-bar :scrollable="true" text="请您严格遵守当地防疫政策，如实填写您孩子的健康码颜色，如虚假填写由此产生的后果自行承担！" />
      <!-- <van-notice-bar
        wrapable
        :scrollable="false"
        text="由于设备网络连接等因素，5分钟内号码才会同步生效！"
      /> -->
      <van-uploader v-model="fileList" multiple 
      :after-read="afterRead" 
      :before-read="beforeRead"
      :max-count="1"   />
      <van-radio-group v-model="radio">
      <van-cell-group>
        <van-cell title="绿码" clickable @click="radio = '1'">
        <template #right-icon>
            <van-radio name="1" />
        </template>
        </van-cell>
        <van-cell title="黄码" clickable @click="radio = '2'">
        <template #right-icon>
            <van-radio name="2" />
        </template>
        </van-cell>
        <van-cell title="红码" clickable @click="radio = '3'">
        <template #right-icon>
            <van-radio name="3" />
        </template>
        </van-cell>
    </van-cell-group>
      </van-radio-group>
        <van-button round block type="primary" style="margin-top:20px"  size="normal" @click="picUpload">上传图片</van-button>
      <!-- <van-cell icon="customiz iconfont icon-icon-test" title="上传图片" @click="picUpload" /> -->

    </div>
  </template>
  
  <script>
  import { Cell, Field, Button, Toast } from 'vant'
  import { NavBar, NoticeBar, CellGroup,Dialog } from 'vant'

  import { Uploader } from 'vant'
  import axios from 'axios'

  var healthforms = null
  export default {
    data() {
      return {
        studentInfo: {},
        fileList: [],
        picfile: null,
        radio: '0'
      }
    },
    computed: {
      
    },
    created() {
        var sinfo = localStorage.getItem("currentChild");
        this.studentInfo = JSON.parse(sinfo);
    },
    methods: {
        afterRead(file) {
            console.log(file)
            this.picfile = file
            healthforms = new FormData();
            healthforms.append("uploadfile", file.file); //获取上传图片信息
        },
        beforeRead(file) {
            console.log(file.type)

		    if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {
		       
		        return true;
		    }
            Toast('请上传图片格式');
		    return false;
		},
        picUpload() {
            //如果文件列表为空，则不需要调用上传
            if(healthforms == null ||healthforms.length == 0){
                return;
            }
            if (this.picfile != null) {
                console.log("picfile",this.picfile)
                this.picfile.status="上传中"
            }
            if (this.radio === "0") {
                Toast("请选择健康码颜色")
                return
            }
            //this.forms.append("deviceid", this.studentInfo.Deviceid); //获取上传图片信息
            //this.forms.append("studentid", this.studentInfo.Studentid); //获取上传图片信息
            axios({
                method: "post",
                url: "/api/healthcodeupload",
                data: healthforms,
                params: {
                    Deviceid:this.studentInfo.Deviceid,
                    Studentid:this.studentInfo.Studentid,
                    Studentname:this.studentInfo.Studentname,
                    qrcode:this.radio
                }
            }).then((res) => {
                if(res.code == 0){
                    Toast.success("上传成功");
                }else{
                    Toast.fail(res.msg);
                    this.picfile.status="上传失败"
                }
            }).catch((err) => {
                Toast.fail("图片上传失败");
            });
        }
    },
    components: {
      'van-notice-bar': NoticeBar,
      'van-field': Field,
      'van-button': Button,
      'van-cell': Cell,
      'van-nav-bar': NavBar,
      'van-uploader':Uploader,
      'van-cell-group': CellGroup
    }
  }
    
  </script>
  
  <style lang="scss" scoped>
  .pay-row-item {
    line-height: 20px;
    .pay-row-item__title {
      display: inline-block;
      width: 70px;
      color: $text-secondary-color;
    }
  }
  .dialog-input {
    display: block;
    width: 275px;
  
    height: 0.8rem;
    line-height: 17px;
    font-size: 15px;
    font-weight: 500;
    color: #999;
    text-indent: 5px;
    border: 1px solid #ddd;
    background: none;
    outline: none;
    margin: 0.6rem auto;
  }
  </style>
  